const initState = {
  poses: []
}

const adminReducer = (state = initState, action) => {
  switch(action.type) {
    case 'GET_POSE_BY_ID': {
      return {
        ...state,
        pose: action.pose
      }
    }
    case 'UPDATE_POSE': {
      return {
        ...state,
        pose: action.pose
      }
    }
    case 'DELETE_POSE': {
      return {
        ...state,
        poses: state.poses.filter(pose => {
          return pose.id !== action.id
        })
      }
    }
    default: 
      return state
  }
}

export default adminReducer